import React from 'react';
import * as XLSX from 'xlsx';

const RFIDReadability = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const rfidData = inspectionData.RFIDReadability;

  if (!rfidData || !rfidData.modules) {
    return <p className="text-gray-500">No RFID Readability data available</p>;
  }

  // Function to download data as Excel (excluding ivParameters)
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet (no IV Parameters since it's an image)
    worksheetData.push(['Date', 'Module ID', 'Line', 'Module']);

    // Populate data for each module
    Object.entries(rfidData.modules).forEach(([moduleKey, moduleData]) => {
      worksheetData.push([
        rfidData.date,
        moduleKey,
        moduleData.line,
        moduleData.module,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'RFIDReadability');
    XLSX.writeFile(workbook, 'RFIDReadabilityData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">
          RFID Readability Data - {rfidData.date}
        </h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      <div className="space-y-4">
        {Object.entries(rfidData.modules).map(([moduleKey, moduleData]) => (
          <div key={moduleKey} className="border-b pb-4">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">{moduleKey}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Text Data */}
              <div>
                <table className="w-full bg-white border rounded-lg">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="px-4 py-2 text-left text-gray-700">Field</th>
                      <th className="px-4 py-2 text-left text-gray-700">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-t">
                      <td className="px-4 py-2 text-gray-600">Line</td>
                      <td className="px-4 py-2 text-gray-600">{moduleData.line || 'N/A'}</td>
                    </tr>
                    <tr className="border-t">
                      <td className="px-4 py-2 text-gray-600">Module</td>
                      <td className="px-4 py-2 text-gray-600">{moduleData.module || 'N/A'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* IV Parameters Image */}
              <div>
                <h4 className="font-semibold text-gray-700 mb-2">IV Parameters Image</h4>
                {moduleData.ivParameters ? (
                  <img
                    src={moduleData.ivParameters}
                    alt={`${moduleKey} IV Parameters`}
                    className="max-w-full h-auto rounded-lg shadow-md"
                    onError={(e) => {
                      e.target.alt = 'Image failed to load';
                      e.target.src = 'https://via.placeholder.com/150?text=Image+Not+Found';
                    }}
                  />
                ) : (
                  <p className="text-gray-500">No IV Parameters image available</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RFIDReadability;